import { ToolsUI } from "./ToolsUI";
import { StandardProps } from "../componentMap";
import {
  ensureIsActive,
  ensureIsActiveVariant,
} from "@/utils/product/ensureIsActive.ts";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { isFutureRelease } from "@/utils/variant/isFutureRelease.ts";
import { isAvailableToPreOrder } from "@/utils/variant/isAvailableToPreOrder.ts";
import { isInStoreOnly } from "@/utils/variant/isInStoreOnly.ts";
import { getVariantSkuId } from "@/utils/variant/getVariantSkuId";

export function Tools({
  product,
  runtimeConfig,
  configProps,
}: Pick<StandardProps, "product" | "runtimeConfig" | "configProps">) {
  const { variant, isSelected } = useVariant(product);
  const {
    storeStockScriptUrl,
    stockApiBaseUrl,
    stockApiKey,
    storeStockApiKey,
    storeStockModalApiUrl,
  } = runtimeConfig;

  const { pdpURL } = variant;
  const activeVariant = ensureIsActiveVariant(variant);
  const isAvailableToOrder =
    activeVariant?.availability.availableToOrder || false;
  const isVariantInStoreOnly = !!activeVariant && isInStoreOnly(activeVariant);

  const canonicalPath = `https://www.johnlewis.com${pdpURL.path}`;

  let buttons;

  if (Array.isArray(configProps?.buttons)) {
    buttons = configProps?.buttons || [];
  }

  return (
    <ToolsUI
      title={variant.title}
      displayCode={variant.displayCode}
      isFutureRelease={isFutureRelease(variant)}
      isPreOrderable={isAvailableToPreOrder(variant)}
      skuId={getVariantSkuId(variant)}
      isActiveProduct={!!ensureIsActive(product)}
      buttons={buttons}
      shareUrl={canonicalPath}
      shareImage={variant.images.primary}
      storeStockApiKey={storeStockApiKey}
      storeStockScriptUrl={storeStockScriptUrl}
      stockApiBaseUrl={stockApiBaseUrl}
      stockApiKey={stockApiKey}
      isVariantSelected={isSelected}
      isStoreStockOnly={isVariantInStoreOnly}
      storeStockModalApiUrl={storeStockModalApiUrl}
      isAvailableToOrder={isAvailableToOrder}
    />
  );
}
